/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { BasicFilter } from '@veeam-vspc/components';

import type { FilterGroup } from '@veeam-vspc/components';
import type { AdvancedFilterValue } from '@veeam-vspc/components/src/AdvancedFilter/interfaces/advanced-filter-value';

import { useLang } from 'views/providers/LangProvider/hooks';
import { SystemTypeRepresentations } from 'core/enums';
import windowsOsTypeIconSrc from 'images/filters/os/windows.svg';
import linuxOsTypeIconSrc from 'images/filters/os/linux.svg';
import macOsTypeIconSrc from 'images/filters/os/mac.svg';

export interface OsTypesFilterProps {
    propName?: string;
}

export const OsTypesToggleFilter: React.FC<OsTypesFilterProps> = ({ propName = 'osTypes' } = {}) => {
    const lang = useLang();

    return (
        <BasicFilter
            name={propName}
            label={lang.GUEST_OS}
            hasAllButton={true}
            buttons={[
                {
                    title: lang.WINDOWS,
                    value: `${SystemTypeRepresentations.Windows}`,
                    icon: windowsOsTypeIconSrc,
                },
                {
                    title: lang.LINUX,
                    value: `${SystemTypeRepresentations.Linux}`,
                    icon: linuxOsTypeIconSrc,
                },
                {
                    title: lang.MAC_OS,
                    value: `${SystemTypeRepresentations.Mac}`,
                    icon: macOsTypeIconSrc,
                },
            ]}
        />
    );
};

export interface UseOsTypesAdvancedFilterProps {
    propName?: string;
}

export const useOsTypesAdvancedFilter = ({ propName = 'osTypes' }: UseOsTypesAdvancedFilterProps = {}): FilterGroup<AdvancedFilterValue> => {
    const lang = useLang();

    return {
        title: lang.GUEST_OS,
        items: [
            {
                iconSrc: windowsOsTypeIconSrc,
                label: lang.WINDOWS,
                value: {
                    id: SystemTypeRepresentations.Windows,
                    name: propName,
                },
            },
            {
                iconSrc: linuxOsTypeIconSrc,
                label: lang.LINUX,
                value: {
                    id: SystemTypeRepresentations.Linux,
                    name: propName,
                },
            },
            {
                iconSrc: macOsTypeIconSrc,
                label: lang.MAC_OS,
                value: {
                    id: SystemTypeRepresentations.Mac,
                    name: propName,
                },
            },
        ],
    };
};
